$(document).ready(function(){

  $('body').on('click', '#submit_note_btn', function(){
    showBlockUI();
  });

});